// extracted by mini-css-extract-plugin
export default {"componentWrapper":"ProfileLoading_componentWrapper__Ak349","progress":"ProfileLoading_progress__e2UqU"};